import { IndividualConfig, ToastrService } from 'ngx-toastr';

/**
 * Muestra un toast controlado por tipo (success | error | warning).
 * 
 * - Permite un solo toast por tipo dentro de una ventana de 3 segundos.
 * - Si se intenta mostrar nuevamente un toast del mismo tipo antes de ese tiempo,
 *   la llamada es ignorada.
 * - El tiempo máximo de visualización del toast es de 3 segundos.
 *
 * @param tipo - Tipo de mensaje ('success' | 'error' | 'warning').
 * @param mensaje - Mensaje a mostrar.
 * @param toastrService - Servicio ToastrService utilizado para mostrar el toast.
 * @param titulo - Título opcional del toast (actualmente no utilizado).
 * @param alinearIzquierdaVp - Indica si el toast debe alinearse a la izquierda
 *                            (útil cuando no está presente la sidebar).
 */
let toastActivo: Record<'success' | 'error' | 'warning', boolean> = {
  success: false,
  error: false,
  warning: false
};

export function mostrarToast(
  tipo: 'success' | 'error' | 'warning',
  mensaje: string,
  toastrService: ToastrService,
  titulo: string = '',
  alinearIzquierdaVp: boolean = false,
  duracionMs: number = 3000
): void {

  if (toastActivo[tipo]) {
    return;
  }

  toastActivo[tipo] = true;

  const opcionesDefault: Partial<IndividualConfig> = {
    toastClass: 'custom-toast',
    timeOut: duracionMs,
    extendedTimeOut: 0
  };

  if (alinearIzquierdaVp) {
    opcionesDefault.toastClass += ' align-vp';
  }

  switch (tipo) {
    case 'success':
      toastrService.success(mensaje, titulo, opcionesDefault);
      break;
    case 'error':
      toastrService.error(mensaje, titulo, opcionesDefault);
      break;
    case 'warning':
      toastrService.warning(mensaje, titulo, opcionesDefault);
      break;
  }

  setTimeout(() => {
    toastActivo[tipo] = false;
  }, duracionMs);
}
